<div class="card mb-30">
	<div class="card-header">
		<h1>Presupuestos</h1>
	</div>
	<div class="card-body">
		<div class="form-group">
			<label for="warehouse" class="form-label">
				Bodega:
			</label>
			<select name="warehouse" id="warehouse" class="form-select" [(ngModel)]="warehouse">
				<option [ngValue]="null">Todas</option>
				<option *ngFor="let w of warehouses" [ngValue]="w.id">{{w.name}}</option>
			</select>
		</div>
	</div>
</div>
<div class="card mb-30">
	<div class="card-header d-flex justify-content-between align-items-center">
		<h3>META DE PRESUPUESTO</h3>
	</div>
	<app-budget-goals-report></app-budget-goals-report>
</div>
<div class="card mb-30">
	<div class="card-header d-flex justify-content-between align-items-center">
		<h3>VENTAS</h3>
	</div>
	<app-budget-sells-report [warehouse]="warehouse"></app-budget-sells-report>
</div>
<div class="card">
	<div class="card-header d-flex justify-content-between align-items-center">
		<h3>PROVEEDORES</h3>
	</div>
	<app-budget-provider-report [warehouse]="warehouse"></app-budget-provider-report>
</div>